import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_IOS_URL } from '../apollo/queries';
import '../App.css';
import girlImage from '../assets/images/girl.webp';
import phoneImage from '../assets/images/phone.webp';
import logoImage from '../assets/images/logo.gif';
import googlePlayImage from '../assets/images/android.webp';
import appStoreImage from '../assets/images/apple.webp';
import qrImage from '../assets/images/qr.webp';
import androidVideo from '../assets/video/android.mp4';
import iosVideo from '../assets/video/ios.mp4';
import { useNavigate } from 'react-router-dom';
import { useLottie } from "lottie-react";
import flow888Image from '../assets/images/flow888.json';

const PLAY_NOW_URL = 'https://web.flow888.win/';

function HomePage() {
    const isClient = typeof navigator !== 'undefined' && typeof window !== 'undefined';
    const ua = isClient ? (navigator.userAgent || navigator.vendor || '') : '';
    const [isPopupOpen, setIsPopupOpen] = React.useState(false);
    const [isVideoPlaying, setIsVideoPlaying] = React.useState(false);
    const [showPlayButton, setShowPlayButton] = React.useState(true);
    const videoRef = React.useRef(null);
    const [imagesLoaded, setImagesLoaded] = useState(0);
    const totalImages = 8; // girl, phone, logo, android, apple
    const isLoading = imagesLoaded < totalImages;

    const options = {
        animationData: flow888Image,
        loop: true,
    };
    const { View } = useLottie(options);

    const lottieContainerRef = React.useRef(null);
    const [lottieHeight, setLottieHeight] = React.useState(0);

    useLayoutEffect(() => {
        if (!lottieContainerRef.current || typeof ResizeObserver === 'undefined') return;

        const el = lottieContainerRef.current;
        const update = () => setLottieHeight(el.clientHeight || 0);

        update();
        const ro = new ResizeObserver(update);
        ro.observe(el);

        return () => ro.disconnect();
    }, [View]);

    const handleImageLoad = () => {
        setImagesLoaded(prev => prev + 1);
    };
    const isAndroid = /Android/i.test(ua);
    const [titleOfButton, setTitleOfButton] = React.useState('Ok');
    const isIOS =
        /iPhone|iPad|iPod/i.test(ua) ||
        (isClient && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPadOS

    const navigate = useNavigate();

    // Function to play video with sound after user interaction
    const playVideoWithSound = async () => {
        if (videoRef.current) {
            try {
                videoRef.current.muted = false; // Ensure sound is on
                await videoRef.current.play();
                setIsVideoPlaying(true);
                setShowPlayButton(false);
                console.log('Video playing with sound');
            } catch (error) {
                console.log('Failed to play video with sound:', error);
            }
        }
    };

    // GraphQL query to get iOS URL
    const { data, loading, error } = useQuery(GET_IOS_URL, {
        errorPolicy: 'all',
        notifyOnNetworkStatusChange: true,
    });

    // Fallback URL if GraphQL query fails or is loading
    const iosUrl = data?.getDownloadUrls?.ios;
    const androidUrl = data?.getDownloadUrls?.android;
    const [closeVideo, setCloseVideo] = React.useState(false);

    const onClose = () => {
        if (isIOS) {
            if (!closeVideo) {
                setCloseVideo(true);
                videoRef.current.pause();
            } else {
                setIsPopupOpen(false);
                window.open(iosUrl, '_blank')

            }
        } else {
            setIsPopupOpen(false);
            videoRef.current.pause();
            window.open(androidUrl, '_blank')
        }
    };

    const openPopup = () => {
        setIsPopupOpen(true);
    };

    const bgImage = require("../assets/images/bg.webp");
    const starImage = require("../assets/images/star.webp");

    return (
        <div className="App">
            {isLoading && (
                <div className="loader-overlay">
                    <div className="loader-spinner"></div>
                </div>
            )}
            <img onLoad={handleImageLoad} src={bgImage} alt="" className='bgImage' />
            <div className='logo'>
                <img onLoad={handleImageLoad} style={{ height: lottieHeight ? lottieHeight + "px" : undefined }} src={starImage} alt="" className='starImageLeft' />
                <img onLoad={handleImageLoad} style={{ height: lottieHeight ? lottieHeight + "px" : undefined }} src={starImage} alt="" className='starImageRight' />
                <div ref={lottieContainerRef}>
                    {View}
                </div>
            </div>
            <div className='container'>
                <div className='mainConten'>

                    <div className='textContainer'>
                        <h1 className='title'>DOWNLOAD</h1>
                        <h1 className='preTitle'>Our Mobile App</h1>
                        <p className='description'>Get the ultimate gaming experience on your device. Available for IOS and Android.</p>
                        {/* <p className='description'></p> */}
                        <img onLoad={handleImageLoad} src={qrImage} alt="" className='qr' />
                        <div className="storeContainer">
                            <button  style={{ cursor: 'pointer', padding: 0, margin: 0, background: 'transparent', border: 0 }}
                                onClick={() => window.open(androidUrl, '_blank')}
                            >
                                <img
                                    
                                    className="store"
                                    src={googlePlayImage}
                                    alt="Google Play"
                                    style={{ flex: 1 }}
                                    onLoad={handleImageLoad}
                                />
                            </button>
                            <button  style={{ cursor: 'pointer', padding: 0, margin: 0, background: 'transparent', border: 0 }}
                                onClick={() => window.open(iosUrl, '_blank')}>
                                <img className="store" src={appStoreImage} alt="App Store" onLoad={handleImageLoad} />
                            </button>
                            <button
                                className="playNowButton"
                                onClick={() => window.open(PLAY_NOW_URL, '_blank')}
                            >
                                Play Now
                            </button>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button onClick={() => openPopup()} className='okButton'>How To Install</button>
                        </div>
                    </div>
                </div>

                <div className="imagesContainer">
                    <div className="phoneContainer">
                        <img className="phone" src={phoneImage} alt="Phone" onLoad={handleImageLoad} />
                    </div>
                    <img className="girlImage" src={girlImage} alt="Girl" onLoad={handleImageLoad} />
                </div>

            </div>

            <div className='popup' style={{ display: isPopupOpen ? 'flex' : 'none' }}>
                <div style={{ position: 'relative', maxWidth: '90%', maxHeight: '70%' }}>
                    {closeVideo ? <div style={{ backgroundColor: 'rgba(0, 0, 0)', padding: '20px', borderRadius: '10px', textAlign: 'center' }}>
                        <p style={{ textAlign: 'center', color: '#fff', fontSize: '16px', fontWeight: 'normal', margin: '0' }}>
                            {'If you already have the app, please delete app and remove certificate from  \n '}
                            <p style={{ textAlign: 'center', color: 'red', fontSize: '16px', fontWeight: 'bold', margin: '0' }}>{'Settings > General > Vpn & Device Management'}</p>
                        </p>
                    </div> :
                        <>
                            <video
                                ref={videoRef}
                                src={isAndroid ? androidVideo : iosVideo}
                                controls={!showPlayButton}
                                playsInline
                                style={{ width: '100%', height: '100%' }}
                            />
                            {showPlayButton && (
                                <button
                                    onClick={playVideoWithSound}
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '80px',
                                        height: '80px',
                                        fontSize: '30px',
                                        cursor: 'pointer',
                                        zIndex: 10
                                    }}
                                >
                                    ▶
                                </button>
                            )}
                        </>
                    }


                </div>

                <button onClick={() => onClose()} className='okButton'>Install Now</button>
            </div>
        </div>
    );
}

export default HomePage;